import { createContext, useContext } from 'react';

export const BtcPriceContext = createContext(null);
export const useBtcPrice = () => useContext(BtcPriceContext);
